import { SubscriptionInformationServicesTabEnum } from './../../../../../../models/my-subscription/my-subscription.models';
import { autoinject } from "aurelia-dependency-injection";
import { useView } from "aurelia-framework";
import { CustomerSubscriptionModel, SubscriptionProductCodes } from "../../../../../../models/customers/customer-subscription.models";
import { TasksConstants } from "../../../../../../models/tasks/task.model";
import { CustomerSubscriptionService } from "../../../../../../services/modules/customer-subscription-client.service";
import { computedFrom } from 'aurelia-binding';
import { CustomerSubscriptionType } from '../../../../../../models/customers/customer.models';
import { type TabModel } from '@rightship-tech/common-ui/models/basic.models';
import { MyVessels } from '../information-services/tabs/my-vessels/my-vessels';
import { VesselChanges } from '../information-services/tabs/vessel-changes/vessel-changes';

@autoinject
@useView('views/pages/modules/my-subscription/tabs/psc-riskiq/psc-riskiq.html')
export class PscRiskIQ {

    public customerSubscription: CustomerSubscriptionModel;
    public childTabs: TabModel[] = [];
    public currentChildTab: TabModel;
    public currentChildTabKey: string = TasksConstants.MyVessels;
    public customerId: number;
    public isFullSubscription: boolean;
    public isRightShipUser: boolean;
    public subscriptionProductCode: string = SubscriptionProductCodes.pscRiskIqInApp;

    @computedFrom('customerId')
    get currentCustomerId(){
        if(this.customerId && (!this.customerSubscription || this.customerSubscription.customerId != this.customerId) ){
            this.getCustomerSubscription().then(() => {
                this.isFullSubscription = this.customerSubscription && this.customerSubscription.subscriptionTypeId == CustomerSubscriptionType.FullSubscription;
                this.childTabs = this.getChildTabs();
                this.setChildCurrentTab();
            });
        }
        return this.customerId;
    }

    constructor(private customerSubscriptionService: CustomerSubscriptionService,
        private myVessels: MyVessels, private vesselChanges: VesselChanges) {
    }

    activate(model: {customerId: number, isRightShipUser: boolean}) {    
        this.customerId = model.customerId;
        this.isRightShipUser = model.isRightShipUser;
    }

    setChildCurrentTab() {
        if (window.history.state && Object.keys(window.history.state).indexOf(TasksConstants.PscRiskIQ) > -1) {
            const tabListName = window.history.state[TasksConstants.PscRiskIQ];
            let step: number = null;

            switch (tabListName) {
                case TasksConstants.MyVessels:
                    step = SubscriptionInformationServicesTabEnum.MyVessels;
                    break;
                case TasksConstants.VesselChanges:
                    step = SubscriptionInformationServicesTabEnum.VesselChanges;
                    break;
            }

            delete window.history.state[TasksConstants.PscRiskIQ];
            window.history.replaceState(window.history.state, "PscRiskIQ");

            if (step != null) {
                const tabs = this.childTabs.filter(x => x.step == step);
                if (tabs && tabs.length > 0)
                    this.currentChildTab = tabs[0];
            }
        }
    }

    getChildTabs(): TabModel[] {
        return [
            {
                title: "My Vessels",
                step: SubscriptionInformationServicesTabEnum.MyVessels,
                show: true,
                vm: this.myVessels
            },
            {
                title: "Vessel Changes",
                step: SubscriptionInformationServicesTabEnum.VesselChanges,
                show: true,
                vm: this.vesselChanges,
                lazyLoad: true
            }
        ]
    }

    async getCustomerSubscription(){
        const response = await this.customerSubscriptionService.getCustomerSubscription(this.customerId, SubscriptionProductCodes.pscRiskIqInApp);
        this.customerSubscription = response.customerSubscription;
    }
}